import React, {Fragment, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import IbatApi from "../../utils/IbatApi";
import "../style/SiteStyle.css"
import IconSite from "../../images/site-name.png"
import UpdateSiteImage from "../forms/UpdateSiteImage";
import {IconButton} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import {text} from "../util/constants";
import {getColor} from "../../helpers/interventionManager";
import InterventionForm from "../forms/InterventionForm";
import UpdateSiteClient from "../forms/UpdateSiteClient";
import Modal from "react-responsive-modal";
import {useSnackbar} from "notistack";
import ShareSiteOrDevis from "../forms/ShareSiteOrDevis";
import GenPdfIcon from "../../images/illust-button-pdf.png"
import PdfBean from "./PdfBean";
import {DocumentLoaderList} from "../util/DocumentLoader";


export default function Site() {

    const {id} = useParams()

    const {enqueueSnackbar, closeSnackbar} = useSnackbar();
    const [siteForm, setSiteForm] = useState(false)
    let api = new IbatApi();
    const mySiret = api.getTokenData()?.siret
    const [state, setState] = useState({})
    const [share, setShare] = useState(false)
    const [interventions, setinterventions] = useState([])
    const [siteClient, setSiteClient] = useState({
        id: null, internal_reference: null, internal_secteur: null, manager: null, siren: null, siret: null, site: null,
        archived: false
    })
    const [pdfPopup, setPdfPopup] = useState(false)
    useEffect(() => {
        getData()
    }, [id])

    function handleSiteForm() {
        setSiteForm(!siteForm)
    }

    function saveSiteClient(data) {
        console.log(data)
        setSiteClient({...siteClient, ...data})
        api.updateClientSite(id, data)
            .then(() => enqueueSnackbar('Données enregistrées avec succès', {variant: "success"}))
            .catch(() => enqueueSnackbar('Une erreur est survenue', {variant: "error"}))
        handleSiteForm()
    }

    function siteArchive() {
        api.siteArchive(id)
            .then(() => {
                getData()
                enqueueSnackbar(text.SNACKBAR_SUCCESS, {variant: "success"})
            })
            .catch(e => enqueueSnackbar(e.message, {variant: "error"}))
    }

    function getData() {
        // api.getSite(id).then(data => setState({...state, ...data}))
        api.getSiteClient(id).then(data => {
            setSiteClient({...siteClient, ...data})
            setState({...state, ...data.site})
        })
        api.getSiteIntervention(id).then(i => setinterventions(i))
    }


    function handleShare(data) {
        api.shareSite(id, data.siren)
            .then(r => enqueueSnackbar(text.SNACKBAR_SUCCESS, {variant: "success"}))
            .catch(r => enqueueSnackbar(text.SNACKBAR_ERROR, {variant: "error"}))
    }

    return (
        <div className={"site-bean"}>
            <div className={"site"}>
                <h1><IconButton disabled={!state?.id || siteClient.archived} onClick={handleSiteForm}><img
                    src={IconSite}/></IconButton>{text.SITE} {id}</h1>
                <div>
                    <div>
                        <h2>{state.name ? state.name : text.NO_NAME}</h2>
                        <p>{state.address}<br/> {state.cp} {state.ville}
                            <br/> {state.status}<br/>{state.contactName}<br/>{state.siret}<br/>
                            <ul>{state.contactPhone?.map(ph => <li>{ph}</li>)}</ul>
                        </p>
                    </div>
                    {<UpdateSiteImage voie={state.address + " " + state.cp + " " + state.ville}
                                      img={state.imageUrl ? state.imageUrl : null} siteId={id} latitude={state.latitude}
                                      longitude={state.longitude} update={getData}/>}


                    <div>
                        {!mySiret &&
                            <div>
                                <Tooltip title={"Partager ce site avec un tiers"}>
                                    <IconButton disabled={!siteClient?.id}
                                                onClick={() => setShare(true)}>Share</IconButton>
                                </Tooltip>
                                <br/>
                            </div>
                        }
                        {(!siteClient?.archived && !mySiret) &&
                            <IconButton disabled={!state?.id} onClick={siteArchive}>Archiver ce site</IconButton>}
                        {siteClient.archived && <div>Ce site est archivé</div>}
                    </div>
                </div>
            </div>
            <div className={"interventions"}>
                <h3>
                    {text.INTERVENTION_HISTORY} ({interventions.length > 0 ? interventions.length : 0})<br/>

                    <InterventionForm onSaveSucceed={getData} site={{...state}}/>
                    <a>+ Nouvelle intervention</a>
                </h3>
                <div style={{width: "fit-content", position: "absolute", right: "4rem", top: "3rem"}}>
                    <Tooltip title={"export pdf"}>
                        <IconButton onClick={() => setPdfPopup(true)}>
                            <img src={GenPdfIcon}/>
                        </IconButton>
                    </Tooltip>

                </div>
                <div className={"table"}>
                    <table>
                        <thead>
                        <tr>
                            <th>{text.ID}</th>
                            <th>{text.FILE_TYPE}</th>
                            <th>{text.STATUS}</th>
                            <th>{text.RECEPTION_DATE}</th>
                            <th>{text.INTERVENTION_START}</th>
                            <th>{text.SERVICE_PROVIDER}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {interventions.map(
                            (value, k) => {
                                return (
                                    <>
                                        <tr key={value.id} style={{background: "rgba(0,255,0,0.45)"}}>
                                            <td><a href={`/intervention/${value.id}`}> {value.id}</a></td>
                                            <td>{value.type.name}</td>
                                            <td>{text.STATUS_TRADUCTION[value.status]}</td>
                                            <td>{value.devis.dateReception ? new Date(value.devis.dateReception).toLocaleDateString() : "-"}</td>
                                            <td>{value.dateIntervention > 0 ? new Date(value.dateIntervention).toLocaleDateString() : "-"}</td>
                                            <td><a
                                                href={`/company/${value.devis?.client?.id}`}>{value.devis?.company?.name}</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>Accès à la toiture</td>
                                            <td colSpan={4}>{value.riskAnalysis.filter(ra => ra.question.includes("Accès à la toiture"))[0]?.answer?.join(",") ?? "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>Epc</td>
                                            <td colSpan={4}>{value.riskAnalysis.filter(ra => ra.question.includes("EPC"))[0]?.answer?.join(",") ?? "N/A"}</td>

                                        </tr>
                                        <tr>
                                            <td colSpan={2}>Type de toiture</td>
                                            <td colSpan={4}>{value.riskAnalysis.filter(ra => ra.question.includes("Type de toiture"))[0]?.answer?.join(",") ?? "N/A"}</td>

                                        </tr>
                                        <tr>
                                            <td colSpan={2}>Devis</td>
                                            <td colSpan={4}><div style={{display: "inline-flex", gap: "3rem"}}>{value.quotations.map(q => <div><DocumentLoaderList name={[q.odooId]} noHeader={true} type={"quotation"}/><a target={"_blank"} href={`/quotation/${q.id}`}>{q.odooRef}</a></div>)}</div></td>

                                        </tr>
                                        <tr>
                                            <td colSpan={6}>
                                                <table style={{width: "100%"}}>
                                                    <thead>
                                                    <tr>
                                                        {
                                                            value.operations
                                                                .sort((a, b) => a.typeName > b.typeName ? 1 : -1)
                                                                .map(operation => {
                                                                    return (
                                                                        <td>{operation.typeName}</td>
                                                                    )
                                                                })
                                                        }
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        {
                                                            value.operations
                                                                .sort((a, b) => a.typeName > b.typeName ? 1 : -1)
                                                                .map(operation => {
                                                                    return (
                                                                        <td style={{
                                                                            padding: "8px",
                                                                            background: operation.metadata.stateLevel !== undefined && operation.metadata.stateLevel !== null ? "undefined" : "rgba(170,170,170,0.67)"
                                                                        }}>
                                                                            <div style={{
                                                                                ...getColor(operation.metadata.stateLevel),
                                                                                margin: "auto",
                                                                                borderRadius: "50%",
                                                                                width: 40,
                                                                                height: 40,
                                                                                border: "3px solid white"
                                                                            }}/>
                                                                        </td>
                                                                    )
                                                                })
                                                        }
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </td>
                                        </tr>
                                        <tr style={{height: '2rem'}}/>
                                    </>
                                )
                            }
                        )}
                        </tbody>

                    </table>
                </div>
            </div>

            <Modal open={siteForm} onClose={handleSiteForm}>
                <UpdateSiteClient siret={state?.siret} siteClient={siteClient} onSave={saveSiteClient}
                                  onCancel={handleSiteForm}/>
            </Modal>
            <Modal open={share} onClose={() => setShare(false)}>
                <ShareSiteOrDevis siteOrDevis={"site"} share={handleShare}/>
            </Modal>
            <Modal open={pdfPopup} onClose={() => setPdfPopup(false)}>
                <PdfBean type={"siteHistory"} onUpload={()=>{setPdfPopup(false)}} payload={{site: {...siteClient.site}, interventions: [...interventions]}}/>
            </Modal>
        </div>
    )
}
